import {AnswerValue} from './answer-value';

export class TimeAnswerValue extends AnswerValue {
  equals(other: TimeAnswerValue): boolean {
    return this.label == other.label && this.format == other.format;
  }
  isValid(): boolean {
    return this.label && this.label.length > 0 && this.format && this.format.length > 0;
  }
  constructor(public label : string, public format : string) { super(label);}
  copy() : AnswerValue {
    return new TimeAnswerValue(this.label, this.format);
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/time-answer-value.ts